import React from 'react';
import { ArrowBack, Typography } from 'housecall-ui';
import Button from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/Button';

type Props = {
  onClick: () => void;
};
export const BackArrowButton = (props: Props) => {
  return (
    <Typography gutterBottom variant="subtitle2">
      <Button data-testid="back-arrow" onClick={props.onClick} style={{ textTransform: 'capitalize' }}>
        <ArrowBack style={{ marginRight: 7, marginLeft: -9, marginBottom: 2 }} width={18} height={18} />
        Back
      </Button>
    </Typography>
  );
};
